import { RegisterPaymentModal } from '@components'

import { ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'

import { useVatDeclaration } from '@features/vatDeclarations/hooks/useVatDeclaration'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { VatDeclarationsRegisterPeriodPaymentModalContextProvider } from './context/vatDeclarationsRegisterPaymentModalContext'
import { ModalDetails } from './elements/ModalDetails'
import { ModalFooter } from './elements/ModalFooter'
import { ModalForm } from './elements/ModalForm'

interface VatDeclarationsRegisterPeriodPaymentModalProps extends ModalProps {
  vatDeclarationId: string
}

export const VatDeclarationsRegisterPeriodPaymentModal = ({
  id,
  vatDeclarationId,
}: VatDeclarationsRegisterPeriodPaymentModalProps): ReactElement => {
  const { vatDeclaration } = useVatDeclaration({ vatDeclarationId })
  const { organization } = useUserOrganization()
  const currency = organization?.baseCurrencyId || 'EUR'

  if (!vatDeclaration) {
    return <></>
  }

  return (
    <VatDeclarationsRegisterPeriodPaymentModalContextProvider modalId={id} vatDeclaration={vatDeclaration}>
      <RegisterPaymentModal
        id={id}
        details={<ModalDetails currency={currency} />}
        form={<ModalForm currency={currency} />}
        footer={<ModalFooter />}
      />
    </VatDeclarationsRegisterPeriodPaymentModalContextProvider>
  )
}
